import React, { useState, useEffect } from 'react'
import { Box, Grid, Link, TextField, MenuItem, BottomNavigationAction } from '@material-ui/core';
import { useStore } from '../../Store'
import Header from '../Header'
import ActionBar from '../ActionBar';
import SaveIcon from '@material-ui/icons/Save';
import { getErrorProps, excrementScales } from '../../utils';

const ObservationDetails = ({ readonly, formik, handleCancel, handleSubmit }) => {
    const { plots, settings } = useStore()
    const [taxItem, setTaxItem] = useState()
 
    const taxLisTaxId = `observation.taxLisTaxId`
    const description = `observation.description`
    const abundance = `observation.abundance`

    const getTaxa = () => {
        let taxaListId
        if (formik.values.prtId) {
            taxaListId= formik.values.prtId
        } else {
            const plot= plots.find(p => p.children.some(child => child.id === formik.values.plot))
            taxaListId= plot.taxaListId
        }
        const taxaList = settings.taxaLists.find(t => t.id === taxaListId)
        return taxaList.taxa.filter(t => t.type === 'row').sort((a, b) => a.sortorder > b.sortorder ? 1 : -1)
    }

    const taxa = getTaxa();

    useEffect(()=> {
        if (formik.values.observation?.taxLisTaxId) {
            setTaxItem(taxa.find(item => item.id === formik.values.observation.taxLisTaxId))
        }
    }, [taxa, formik.values.observation])

    const species = () => {
        return taxa.map(item => {
            return (
                <MenuItem key={item.id} value={item.id}>
                    {item.name}, {item.name2}
                </MenuItem>
            )
        })
    }
    const scaleItems = () => {
        return excrementScales().map(item => {
            return (
                <MenuItem key={item.code} value={item.code}>
                    {item.description}
                </MenuItem>
            )
        })
    }

    const changeTaxLisTaxId = (e) => {
        const item = taxa.find(t => t.id === e.target.value)
        const observation= formik.values.observations.find(o => o.taxLisTaxId === item.id)
        if (observation) {
            formik.setFieldValue('observation', JSON.parse(JSON.stringify(observation)))
            formik.setFieldValue(abundance, observation.abundance)
        } else {
            formik.setFieldValue(abundance, (item.info.scale === 'exact_count' ? '0' : 'I' ))
        }
        setTaxItem(item)
        formik.setFieldValue(description, item ? `${item.name}, ${item.name2}` : "")
        formik.handleChange(e)
    }


    return (
        formik.values.observation &&
        <>
            <Header title={formik.values.observation.description || 'Nieuwe waarneming'} backAction={handleCancel} />
            <Box m={2}>
                <Grid container>

                    <Grid item xs={12}>
                        <TextField required select disabled={readonly} label="soort" variant="standard" name={taxLisTaxId} fullWidth
                            {...formik.getFieldProps(taxLisTaxId)}
                            onChange={changeTaxLisTaxId}
                            {...getErrorProps(formik, taxLisTaxId)}
                        >
                            {species()}
                        </TextField>
                    </Grid>

                    <Grid item xs={12}>
                    {taxItem && taxItem.info.scale === 'exact_count' &&
                        <TextField required disabled={readonly} label="aantal" variant="standard" name={abundance} fullWidth  {...getErrorProps(formik, abundance)} {...formik.getFieldProps(abundance)} />
                    }
                    {taxItem && taxItem.info.scale === 'amount/bat_excrements' &&
                        <TextField required select disabled={readonly} label="mest" variant="standard" name={abundance} fullWidth  
                            {...formik.getFieldProps(abundance)}
                            {...getErrorProps(formik, abundance)} 
                        >
                            {scaleItems()}
                        </TextField>
                    }
                    </Grid>

                </Grid>
            </Box>
            {!readonly &&
                <ActionBar>
                    {!readonly && <BottomNavigationAction label="Waarneming opslaan" component={Link} to="/" onClick={handleSubmit} style={{ color: '#00547d' }} icon={<SaveIcon />} />}
                </ActionBar>}
        </>
    )
}

export default ObservationDetails
